// @ts-check

/** @type {string} */
export const currentPath = window.location.pathname
/** @type {RegExp} */
export const re = /\/(lists|search)\/?.*/

/**
 * @param {RegExp} re
 * @param {string} currentPath
 * @returns {boolean}
 */
export function checkProSearchPath(re, currentPath) {
  if (currentPath.match(re)) {
    return true
  } else {
    return false
  }
}
